import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@dashboard/hooks/useAuth';

export default function AdminProtectedRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#09090b] flex items-center justify-center">
        <div className="text-zinc-500 font-mono text-sm tracking-wider uppercase">Loading...</div>
      </div>
    );
  }

  if (!user || user.app_metadata?.role !== 'admin') {
    return <Navigate to="/04062001/admin-login" replace />;
  }

  return <Outlet />;
}
